var map = {
	"./bbc.svg": 80631,
	"./bt-color-new.svg": 1673,
	"./bt-color.svg": 65174,
	"./capita-color.svg": 44042,
	"./cs/alt-bank.svg": 58151,
	"./cs/alt-big-4.svg": 86849,
	"./cs/alt-bt.svg": 85649,
	"./cs/alt-global-retailer.svg": 76649,
	"./cs/alt-gsc.svg": 88394,
	"./cs/alt-nhs.svg": 38975,
	"./cs/alt-pub-sap.svg": 90779,
	"./cs/api-group.svg": 38018,
	"./cs/api.svg": 46212,
	"./cs/bank.svg": 67820,
	"./cs/bt.svg": 23300,
	"./cs/deloitte.svg": 4299,
	"./cs/flydocs.svg": 71351,
	"./cs/ford.svg": 2386,
	"./cs/global-retailer.svg": 53710,
	"./cs/gsc.svg": 59848,
	"./cs/hcuk.svg": 26529,
	"./cs/innovator-international.svg": 30920,
	"./cs/nhs.svg": 48716,
	"./cs/pub-sap.svg": 78885,
	"./cs/reed.svg": 60579,
	"./cs/tac.svg": 98594,
	"./cs/zappi.svg": 32574,
	"./ct.svg": 97043,
	"./deloitte-color.svg": 46003,
	"./fca-color.svg": 95381,
	"./fca.svg": 93421,
	"./flydocs.svg": 77342,
	"./ford-color.svg": 1748,
	"./forrester.svg": 14021,
	"./mbnl.svg": 50138,
	"./nhs-color.svg": 24540,
	"./nhs-logo/nhs-logo.png": 26027,
	"./nhs-logo/nhs-logo.webp": 91791,
	"./nhs.svg": 43815,
	"./publicis-sapient-logo.svg": 84298,
	"./publicis-sapient-new.svg": 8093,
	"./santander-color.svg": 82647,
	"./tac-color.svg": 49945,
	"./zappi-color.svg": 68196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72901;